import { UID } from 'shared/api/query/constants';

import { DEFAULT_SIDEBAR_WIDTH } from '@/lib/constants';
import { defaultTimezone } from 'shared/lib/time';
import { goalCycle as goalCycleConfig, personalAppSettings as personalAppSettingsConfig } from 'shared/api/query/configs.json';

export const personalAppSettingsEdges = [
  { attr: UID },
  { attr: personalAppSettingsConfig.edges.unassignedGoalCycleSelected, default: false },
  { attr: personalAppSettingsConfig.edges.desktopSidebarHidden, default: false },
  { attr: personalAppSettingsConfig.edges.mainSidebarWidth, default: DEFAULT_SIDEBAR_WIDTH },
  { attr: personalAppSettingsConfig.edges.goalSidePeekWidth, default: 700 },
  { attr: personalAppSettingsConfig.edges.goalViewMode, default: null },

  { attr: personalAppSettingsConfig.edges.timezone, default: defaultTimezone() },
  { attr: personalAppSettingsConfig.edges.myWorkspaceOrder, default: [] },
  { attr: personalAppSettingsConfig.edges.favoritesOrder, default: [] },
  { attr: personalAppSettingsConfig.edges.readReleaseNotes, default: [] },
  {
    attr: personalAppSettingsConfig.edges.selectedGoalCycles,
    default: [],
    model: goalCycleConfig.model,
    children: [{ attr: UID }],
  },
];
